import React from 'react';
import Select from 'react-select'; // Import react-select
import { Grid, Container, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { validateLedgerCurrentYear } from 'utils/validationUtils';
import Loader from 'utils/Loader';
import LedgerPreviousYearController from 'pages/Controller/LedgerPreviousYearController';
import { TableFooter } from '../../../node_modules/@mui/material/index';

const LedgerPreviousYear = () => {
  const {
    ledgerData,
    totalDebit,
    totalCredit,
    formData,
    cloading,
    errors,
    customeroptions,
    handleCustomerChange,
    handleSubmit,
    handleInputChange,
    handleViewClick,
    handleDownloadAll,
    handleDownloadClick
  } = LedgerPreviousYearController(
    {
      customer: ''
    },
    validateLedgerCurrentYear
  );

  return (
    <div className="bg" style={{ display: 'block' }}>
      {cloading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please Wait....</span>
        </div>
      ) : null}
      <Container>
        <div className="cutrange">
          <span className="font20">Ledger Previous Year</span>
        </div>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          {JSON.parse(localStorage.getItem("user")).userVerticalId !== "Garment" && (
            <>
              <Grid item xs={8}>
                <Select
                  options={customeroptions} // Options for the dropdown
                  value={formData.customer} // Selected value
                  onChange={handleCustomerChange} // Handle selection change
                  placeholder="Select Party"
                  isClearable // Option to clear the selected value
                  menuPortalTarget={document.body} // Render the dropdown outside the table's container
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} // Ensure dropdown is above other elements
                  onInputChange={handleInputChange}
                />
                {errors.customer == null || errors.customer === '' ? <p className="no-error">.</p> : <p className="error">{errors.customer}</p>}
              </Grid>
              <Grid item xs={2}>
                <Button fullWidth variant="contained" color="primary" onClick={handleSubmit}>
                  GO
                </Button>
              </Grid>
            </>
          )}
          <Grid item xs={2}>
            <Button fullWidth variant="contained" color="primary" onClick={handleDownloadAll}>
              Download All
            </Button>
          </Grid>
        </Grid>

        {/* Ledger Table */}
        <TableContainer component={Paper} sx={{ maxHeight: '500px', overflowY: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Month
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Opening Balance
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Debit
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Credit
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Balance
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  View Ledger
                </TableCell>
                <TableCell align="center" sx={{ color: 'white', backgroundColor: 'red' }}>
                  Download
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ledgerData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#e0e0e0' // Zebra-striping effect
                  }}
                >
                  <TableCell align="center">{row.monthname}</TableCell>
                  <TableCell align="center">{row.opening_balance}</TableCell>
                  <TableCell align="center">{row.debit}</TableCell>
                  <TableCell align="center">{row.credit}</TableCell>
                  <TableCell align="center">{row.balance}</TableCell>
                  <TableCell align="center">
                    <Button variant="text" color="primary" onClick={() => handleViewClick(row)} disabled={!row.viewledger}>
                      View
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <Button variant="text" color="primary" onClick={() => handleDownloadClick(row)} disabled={!row.viewledger}>
                      Download
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow sx={{ color: 'black' }}>
                <TableCell align="center"></TableCell>
                <TableCell align="center" sx={{ color: 'black' }}>
                  Total
                </TableCell>
                <TableCell align="center" sx={{ color: 'black' }}>
                  {totalDebit}
                </TableCell>
                <TableCell align="center" sx={{ color: 'black' }}>
                  {totalCredit}
                </TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Container>
    </div>
  );
};

export default LedgerPreviousYear;
